import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=331f33f1&scoped=true"
import script from "./PortalLogin.vue?vue&type=script&lang=js"
export * from "./PortalLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f33f1",
  null
  
)

export default component.exports